import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../layout/Layout.js';
import Section, { SectionTitle } from '../../common/Section.js';
import Card, { CardImage, CardBody } from '../../common/Card.js';
import Button from '../../common/Button.js';
import styled from 'styled-components';

const BlogGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 2rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const BlogCard = styled(Card)`
  .meta {
    display: flex;
    gap: 1rem;
    font-size: 0.875rem;
    color: var(--gray);
    margin-bottom: 1rem;
    
    .category {
      color: var(--secondary);
      font-weight: 600;
    }
  }
`;

const BlogPage = () => {
  // Blog post data (this would normally come from an API or CMS)
  const posts = [
    {
      id: 1,
      title: "7 Things to Look for When Buying a New Home",
      excerpt: "Discover the key features to consider when purchasing a new home to ensure it meets your needs and provides value for years to come.",
      date: "March 15, 2023",
      category: "Buying Tips",
      image: "/images/blog1.png"
    },
    {
      id: 2,
      title: "Understanding the Home Building Process",
      excerpt: "A step-by-step guide to the home construction process from initial planning and design to final walkthrough and closing.",
      date: "February 28, 2023",
      category: "Construction",
      image: "/images/blog2.png"
    },
    {
      id: 3,
      title: "Investment Opportunities in NC Triad Real Estate",
      excerpt: "Explore the growing real estate market in the North Carolina Triad area and learn about potential investment opportunities.",
      date: "January 12, 2023",
      category: "Investment",
      image: "/images/blog3.png"
    },
    {
      id: 4,
      title: "Partnering for Land Development: A Smart Investment Opportunity",
      excerpt: "Discover how partnering with an experienced builder can unlock the full potential of your land in the growing NC Triad region.",
      date: "April 17, 2023",
      category: "Land Development",
      image: "/images/blog3.png",
      path: "/blog/land-development" // Custom path for this blog post
    }
  ];
  
  return (
    <Layout>
      <Section>
        <div className="container">
          <SectionTitle>
            <h2>Our Blog</h2>
            <p>News, tips, and insights from Shoffner Homes</p>
          </SectionTitle>
          
          <BlogGrid>
            {posts.map(post => (
              <BlogCard key={post.id}>
                <CardImage height="220px">
                  <img src={post.image} alt={post.title} />
                </CardImage>
                <CardBody>
                  <div className="meta">
                    <span className="date">{post.date}</span>
                    <span className="category">{post.category}</span>
                  </div>
                  <h3>{post.title}</h3>
                  <p>{post.excerpt}</p>
                  <Button as={Link} to={post.path || `/blog/${post.id}`} variant="text">
                    Read More
                  </Button>
                </CardBody>
              </BlogCard>
            ))}
          </BlogGrid>
        </div>
      </Section>
    </Layout>
  );
};

export default BlogPage;